<template>
  <v-container
    fluid
    grid-list-md
    fill-height
  >
    <v-layout
      row
      wrap
    >
      <v-flex>
        <v-progress-linear
          indeterminate
          height="2"
          v-if="fetching"
        ></v-progress-linear>
        <router-view v-else-if="translator"></router-view>
        <v-alert
          :value="true"
          color="white"
          class="grey--text"
          icon="info"
          v-else
        >
          נתוני מתורגמן לא נמצאו. נסו לטעון את הדף מחדש
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      fetching: true
    };
  },
  computed: {
    translatorId() {
      return this.$route.params.id;
    },
    translator() {
      return this.$store.getters["entity"]("translators", this.translatorId);
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
  },
  methods: {
    fetch() {
      this.fetching = true;
      this.$store
        .dispatch("API_GET", {
          url: "/translators/" + this.translatorId,
          entityType: "translators",
          schema: "translatorListSchema"
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/translators/Translator.vue